// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"8db75690","168":"7afc32df","176":"80cca111","188":"b838dd91","212":"e83e4834","240":"75069f7d","496":"37a28473","528":"c2a8d074","544":"d9b0e633","592":"a33c00ce","624":"874d0cc8","640":"7cb967bb","832":"b37e8815","856":"aef3ab68","960":"7e5407b7"}[chunkId] + ".chunk.js";
};